import BulletPoint from "@components/BulletPoint"
import { useTranslation } from "react-i18next"

interface Props {
  isWhatsappFunnel?: boolean
}

export default function Features({ isWhatsappFunnel = false }: Props) {
  const { t } = useTranslation()

  return (
    <div className="space-y-11 font-bold">
      {isWhatsappFunnel && (
        <BulletPoint
          text={t("pages.checkout.plans.bulletPoints.whatsapp-1")}
          title={t("pages.checkout.plans.bulletPoints.whatsapp")}
        />
      )}

      <BulletPoint
        text={t("pages.checkout.plans.bulletPoints.1-1")}
        title={t("pages.checkout.plans.bulletPoints.1")}
      />

      <BulletPoint
        text={t("pages.checkout.plans.bulletPoints.2-1")}
        title={t("pages.checkout.plans.bulletPoints.2")}
      />

      <BulletPoint
        text={t("pages.checkout.plans.bulletPoints.3-1")}
        title={t("pages.checkout.plans.bulletPoints.3")}
      />

      <BulletPoint
        text={t("pages.checkout.plans.bulletPoints.4-1")}
        title={t("pages.checkout.plans.bulletPoints.4")}
      />
    </div>
  )
}
